import "./App.css";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import ReactPixel, { init } from 'react-facebook-pixel';
import React, { useState, useContext, useEffect } from 'react';

import Landing from "./components/QuestionStep/Landing";
import Questions from "./components/Questions";
import Home from "./components/Home";
import Middle from "./components/Middle";
import CulcRes from "./components/CulcRes";
import ResultShare from "./components/ResultShare";
import Form from "./components/Form";
import ThankYou from "./components/ThankYou";
import { AppContext } from './contexts/AppProvider'
import {Helmet} from "react-helmet";
import { useLocalize } from 'localize-react';



function App() {
  
  // useEffect(() => {
  //   document.title = translate('headTitle');
  // });
  const {toggleAnimation, settings} = useContext(AppContext)
  let searchParams = decodeURIComponent(window.location.search)
  const { translate } = useLocalize();

  if (searchParams.includes('email')) {
    localStorage.setItem("registered", true);

      // console.log('searchParams', searchParams)
    if(searchParams.indexOf("&")>-1){
      // console.log('split', searchParams.replace("?email=").split("&")[0])
      localStorage.setItem("email", searchParams.replace("?email=","").split("&")[0]);  
    }
    else{
      localStorage.setItem("email", searchParams.replace("?email=",""));
    }    
  } else {
    localStorage.setItem("registered", false);
  }


  ReactPixel.init('412777243572320');
  ReactPixel.pageView();

  //Fix for 100vh on mobile devices
  var appHeight = function appHeight() {
    var doc = document.documentElement;
    doc.style.setProperty('--app-height', "".concat(window.innerHeight, "px"));
  };

  window.addEventListener('resize', appHeight);
  appHeight(); 

  return (
      <div className="App">
        <Helmet>
          <title>{translate('headTitle')}</title>
          <meta name="description" content={translate('headDescription')} />
          <meta property='og:title' content={translate('headDescription')} />

        </Helmet>
          <Router basename={'/calc'}>
            <Switch>
              <Route path="/" exact component={Home}   />
              <Route path="/Middle" exact component={Middle} />
              <Route path="/CulcRes" exact component={CulcRes} />
              <Route path="/ResultShare" exact component={ResultShare} />
              <Route path="/Form" exact component={Form} />
              <Route path="/ThankYou" exact component={ThankYou} />
              <Landing>
                <Route path="/Q"  component={Questions} />
              </Landing>
          
            {/* <Route component={Home} /> */}
            </Switch>
          </Router>
        <button title="הפעל \ הפסק אנימציות" aria-label="הפעל \ הפסק אנימציות" className={`${settings.isAnimationPause ? 'play-bg': 'stop-bg'} stop-btn`} onClick={ (e) => {
          e.preventDefault()
            toggleAnimation()
        } }></button>
      </div>
  );
}

export default App;
